<template>
  <div class="sf-el name-input">
    <div class="sf-name">
      <label class="sf-el__label">
        {{ label }}
        <span v-if="required" class="sf-el__required">*</span>
      </label>
      <p v-if="caption" class="sf-el__caption">{{ caption }}</p>

      <!-- Split Names Mode -->
      <div v-if="splitNames" class="name-fields">
        <div class="name-field">
          <input
            type="text"
            v-model="firstName"
            autocomplete="given-name"
            :placeholder="firstNamePlaceholder || 'Voornaam'"
            class="name-input__field"
          />
        </div>
        <div class="name-field">
          <input
            type="text"
            v-model="lastName"
            autocomplete="family-name"
            :placeholder="lastNamePlaceholder || 'Achternaam'"
            class="name-input__field"
          />
        </div>
      </div>

      <!-- Single Name Mode -->
      <input
        v-else
        type="text"
        v-model="value"
        autocomplete="name"
        :placeholder="placeholder || 'Volledige naam'"
        class="name-input__field"
      />
    </div>
  </div>
</template>

<script>
  import { watch, ref, computed } from 'vue';
  export default {
    name: 'NameElement',
    props: {
      label: String,
      caption: String,
      placeholder: String,
      firstNamePlaceholder: String,
      lastNamePlaceholder: String,
      name: String,
      modelValue: [String, Object],
      required: Boolean,
      splitNames: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      // Single name mode
      const value = ref(typeof props.modelValue === 'string' ? props.modelValue : '');

      // Split names mode
      const firstName = ref('');
      const lastName = ref('');

      // Initialize split names if modelValue is an object
      if (props.splitNames && typeof props.modelValue === 'object' && props.modelValue) {
        firstName.value = props.modelValue.first_name || '';
        lastName.value = props.modelValue.last_name || '';
      }

      // Watch single name changes
      watch(value, (newValue) => {
        if (!props.splitNames) {
          emit('update:modelValue', newValue);
        }
      });

      // Watch split names changes
      watch(
        [firstName, lastName],
        ([newFirstName, newLastName]) => {
          if (props.splitNames) {
            emit('update:modelValue', {
              first_name: newFirstName,
              last_name: newLastName,
              full_name: `${newFirstName} ${newLastName}`.trim(),
            });
          }
        },
        { deep: true }
      );

      // Watch modelValue prop changes
      watch(
        () => props.modelValue,
        (newValue) => {
          if (props.splitNames && typeof newValue === 'object' && newValue) {
            firstName.value = newValue.first_name || '';
            lastName.value = newValue.last_name || '';
          } else if (!props.splitNames && typeof newValue === 'string') {
            value.value = newValue;
          }
        }
      );

      return {
        value,
        firstName,
        lastName,
      };
    },
  };
</script>

<style scoped lang="scss">
  .name-fields {
    display: flex;
    gap: 1rem;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 0.75rem;
    }
  }

  .name-field {
    flex: 1;
  }

  .name-input__field {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid var(--slate-300);
    border-radius: 6px;
    font-size: 1rem;
    transition: border-color 0.2s ease;

    &:focus {
      outline: none;
      border-color: var(--brand-500);
      box-shadow: 0 0 0 3px rgba(var(--brand-500-rgb), 0.1);
    }
  }
</style>
